import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import useInput from "../hooks/useInput";
import "./Profile.css";
import Compressor from "compressorjs";
import { Namespaces } from "../components/LanguageSelector";

function Profile({ data, onLogout, onUpdate }) {
  const [editMode, setEditMode] = useState(false);
  const fileInputRef = useRef(null);
  const imgRef = useRef(null);

  const { t } = useTranslation();

  useEffect(() => {
    if (fileInputRef.current) {
      fileInputRef.current.addEventListener("change", (e) => {
        const { files } = e.target;
        if (files && files[0]) {
          var reader = new FileReader();

          reader.onload = function (e) {
            imgRef.current.src = e.target.result;
          };

          reader.readAsDataURL(files[0]); // convert to base64 string
        }
      });
    }
  }, [editMode]);

  const { value: nameValue, bind: nameBind, reset: resetName } = useInput(
    data.name
  );

  const { value: phoneValue, bind: phoneBind, reset: resetPhone } = useInput(
    data.phone
  );

  const {
    value: birthdateValue,
    bind: birthdateBind,
    reset: resetBirthdate,
  } = useInput(data.birthdate);

  const resetInputs = () => {
    resetName();
    resetPhone();
    resetBirthdate();

    imgRef.current.src = data.photoUrl || "/logo.jpg";
  };

  const onSaveCb = () => {
    if (onUpdate) {
      const updatedData = {
        name: nameValue,
        phone: phoneValue,
        birthdate: birthdateValue,
      };

      if (
        fileInputRef.current &&
        fileInputRef.current.files &&
        fileInputRef.current.files[0]
      ) {
        const file = fileInputRef.current.files[0];

        if (!file) {
          return;
        }

        // compress image and trigger update
        new Compressor(file, {
          quality: 0.6,
          width: 512,
          height: 512,
          success(result) {
            updatedData.photo = result;
            onUpdate(updatedData);
          },
          error(err) {
            onUpdate(updatedData);
          },
        });
      } else {
        onUpdate(updatedData);
      }
    }
    setEditMode(false);
    // resetInputs();
  };

  const onCancelCb = () => {
    setEditMode(false);
    resetInputs();
  };
  return (
    <div className="container mt-3 profile">
      <div className="row">
        <div className="col-12 col-lg-12">
          <div className="shadow-sm bg-white pb-2">
            <div className="mb-3 ">
              <img
                ref={imgRef}
                src={data.photoUrl || "/logo.jpg"}
                alt={t(`${Namespaces.profile}.profileImageAltText`)}
                className="profile__img rounded-top"
              />
            </div>
            <div className=" m-1 p-3 rounded text-center">
              {editMode ? (
                <>
                  <div className="mb-1 small text-muted">
                    {t(`${Namespaces.profile}.editModeDescription`)}
                  </div>
                  <div className="input-group mb-3">
                    <div className="custom-file">
                      <input
                        type="file"
                        ref={fileInputRef}
                        className="custom-file-input"
                        id="inputGroupFile02"
                      />
                      <label
                        className="custom-file-label"
                        htmlFor="inputGroupFile02"
                      >
                        {t(`${Namespaces.profile}.fileInputLabel`)}
                      </label>
                    </div>
                  </div>
                  <div className="mb-1 small text-muted">
                    {t(`${Namespaces.profile}.nameInputLabel`)}
                  </div>
                  <div className="mb-3 input-group input-group-lg">
                    <input className="form-control text-center" {...nameBind} />
                  </div>

                  <div className="mb-1 small text-muted">
                    {t(`${Namespaces.profile}.phoneNumberInputLabel`)}
                  </div>
                  <div className="mb-3 input-group">
                    <input
                      className="form-control text-center"
                      {...phoneBind}
                    />
                  </div>
                  <div className="mb-1 small text-muted">
                    {t(`${Namespaces.profile}.birthdateInputLabel`)}
                  </div>
                  <div className="mb-3 input-group">
                    <input
                      className="form-control text-center"
                      {...birthdateBind}
                    />
                  </div>
                  {data.playlist ? (
                    <div className="mb-2">
                      <a
                        href={data.playlist}
                        className="btn btn-link text-primary"
                      >
                        {t(`${Namespaces.profile}.playlistButtonText`)}
                      </a>
                    </div>
                  ) : null}
                </>
              ) : (
                <>
                  <h3 className="mb-3">{t(`${Namespaces.profile}.editModeDescription`)}</h3>
                  <div className="mb-2">{t(`${Namespaces.profile}.phoneNumberInputLabel`)}</div>
                  <div className="mb-2">{t(`${Namespaces.profile}.birthdateInputLabel`)}</div>
                  {data.playlist ? (
                    <div className="mb-2">
                      <a
                        href={data.playlist}
                        className="btn btn-link text-primary"
                      >
                        {t(`${Namespaces.profile}.playlistButtonText`)}
                      </a>
                    </div>
                  ) : null}
                </>
              )}
            </div>
          </div>

          <div className="m-1 p-3 text-center">
            <div className="pb-3">
              {editMode ? (
                <>
                  <button
                    type="button"
                    className="btn btn-primary btn-sm mr-3"
                    onClick={onSaveCb}
                  >
                    {t(`${Namespaces.profile}.saveButtonText`)}
                  </button>

                  <button
                    type="button"
                    className="btn btn-secondary btn-sm"
                    onClick={onCancelCb}
                  >
                    {t(`${Namespaces.profile}.cancelButtonText`)}
                  </button>
                </>
              ) : (
                <button
                  type="button"
                  className="btn btn-primary btn-sm mr-3"
                  onClick={() => setEditMode(true)}
                >
                  {t(`${Namespaces.profile}.editButtonText`)}
                </button>
              )}
              {onLogout && !editMode ? (
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={onLogout}
                >
                  {t(`${Namespaces.profile}.logoutButtonText`)}
                </button>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Profile;
